const addToCart = document.querySelector('.product-form__buttons');
const stickyContainer = document.querySelector('#sticky-container');
const header = document.querySelector('.section-header');

document.body.addEventListener('scroll', () => { 
    const item = addToCart.getBoundingClientRect(); 
    if(item.bottom <= 0) {
        stickyContainer.classList.add('active');
        header.classList.add('hide');
    }else {
        stickyContainer.classList.remove('active');
        header.classList.remove('hide');
    }
});